import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import {
  // useMetaStore,
  useCommonStore,
  useAlertStore,
  // useUserStore,
} from '@stores';
// import { ROUTE_NAME } from '@constants';

const Router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to?.hash) {
      return { el: to?.hash };
    } else {
      // always scroll to top
      return { top: 0 };
    }
  },
  linkExactActiveClass: 'route-active',
});

Router.beforeEach(async (to) => {
  const commonStore = useCommonStore();
  const alertStore = useAlertStore();

  if (to.meta.requiresAuth && !commonStore.isSignIn) {
    await alertStore.showAlertDialog('로그인이 필요합니다');
    return '/auth/signin';
  }

  if (to.meta.isReady) {
    await alertStore.showAlertDialog('준비중 입니다.');
    return false; // 네비게이션 취소
  }

  // 네비게이션을 계속 진행
});

export default Router;
